import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const currencyMask = rawValue => {
  let numberMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalLimit: 2,
    requireDecimal: true,
  });
  rawValue = isNaN(parseFloat(rawValue)) ? '0' : rawValue;
  let mask = numberMask(rawValue);

  return mask;
};

//function for handling decimal places.
const currencyBlur = (event, props) => {
  let mask = event.target.value;
  // in case value is inputted then check for decimal places.
  if (mask) {
    const decimalsRegex = /\.([0-9]{1,2})/;
    const result = decimalsRegex.exec(event.target.value);

    // In case there is only one decimal
    if (result && result[1].length < 2) {
      mask += '0';
    } else if (!result) {
      // in case user didn't input a decimal then add decimal also
      if (mask.indexOf('.') === -1) mask += '.00';
      // else add decimal places
      else mask += '00';
    }

    //pass back the changed value to save in state
    if (mask !== event.target.value && props.onChange) {
      props.onChange({ target: { value: mask } });
    }
  }
  //pass event to existing blur if defined.
  if (props.onBlur) {
    props.onBlur(event);
  }
};

const NumberMask = props => {
  const { inputRef, ...other } = props;
  React.useEffect(() => {
    currencyBlur({ target: { value: props.value } }, { onChange: props.onChange });
  }, []);
  return (
    <MaskedInput
      {...other}
      onBlur={e => currencyBlur(e, props)}
      ref={ref => inputRef && inputRef(ref ? ref.inputElement : null)}
      mask={currencyMask}
      guide={false}
      showMask
    />
  );
};

NumberMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default NumberMask;
